import { Deserializable } from 'rome-library';

export class User implements Deserializable {
  UserName: string;
  Permissions: Array<string>;
  UserId: string;
  UserForename: string;
  UserSurname: string;
  ContactNumber: string;
  CompanyName: string;
  ProfileComplete: boolean;
  DaysUntilPasswordExpire: number;
  FullName: string;
  IsAuthenticated: boolean;
  IsPhoneValidated?: boolean;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.FullName = `${this.UserForename} ${this.UserSurname}`;

    return this;
  }
}
